export default __webpack_public_path__ + "static/media/living-room-2569325_640.6ec562f2.jpg";